import { useContext } from 'react';

import { IAuth } from '@/modules/auth/types';
import { IAuthContext } from '@/shared/hooks/context/auth/IAuthContext';

import AuthContext from './context';

export default function useAuth() {
  return useContext<IAuthContext.IAuthContextProps<IAuth.IUser | null>>(
    AuthContext
  );
}
